import { useMutation } from '@tanstack/react-query';
import { useKeycloak } from '@react-keycloak/web';
import { RuleGroupType } from 'react-querybuilder';

export interface UpsertPayload {
  query: RuleGroupType;
  esQuery: string;
  title: string;
  organisationUuid: string;
}

export function useUserOrganisationAddColletion() {
  const { keycloak } = useKeycloak()

  return useMutation({
    mutationFn: async (payload: UpsertPayload) => {
      const res = await fetch(
        `${
          import.meta.env.VITE_USER_ENGINE_ENDPOINT
        }/api/v1/bundles/user_bundle/functions/add_organisation_collection`,
        {
          headers: {
            'Content-Type': 'application/json',
            'Authorization': `Bearer ${keycloak.token}`
          },
          method: 'POST',
          body: payload ? JSON.stringify(payload) : '',
        }
      );

      return res.json();
    },
  });
}
